import clsx from 'clsx'

interface ShortcutHintProps {
  keys: string[]
  className?: string
}

export function ShortcutHint({ keys, className }: ShortcutHintProps) {
  return (
    <kbd
      className={clsx(
        'inline-flex h-5 shrink-0 items-center justify-center rounded border px-1.5 font-sans text-[10px] font-medium leading-none tracking-[0.01em]',
        className
      )}
    >
      {keys.join('+')}
    </kbd>
  )
}
